import { PerformanceReturn } from '../models/performance-return';
import { Portfolio } from '../models/portfolio';
import { RiskAnalytics } from '../models/risk-analytics';
import { Security } from '../models/security';

export class PortfolioBuilder {
	private portfolio: Portfolio;

	constructor() {
		this.portfolio = new Portfolio();
	}

	public setApplications(applications: Array<string>): PortfolioBuilder {
		this.portfolio.applications = applications;
		return this;
	}

	public setBaseModel(baseModel: number): PortfolioBuilder {
		this.portfolio.baseModel = baseModel;
		return this;
	}

	public setDescription(description: string): PortfolioBuilder {
		this.portfolio.description = description;
		return this;
	}

	public setExpenseRatio(analyticsMap: any): PortfolioBuilder {
		this.portfolio.expenseRatio = analyticsMap ? (analyticsMap.expense ? analyticsMap.expense.value : null) : null;
		return this;
	}

	public setFlags(flags: any): PortfolioBuilder {
		this.portfolio.flags = flags;
		return this;
	}

	public setOrigin(origin: string): PortfolioBuilder {
		this.portfolio.origin = origin;
		return this;
	}

	public setSubType(subType: string): PortfolioBuilder {
		this.portfolio.subType = subType;
		return this;
	}

	public setType(type: string): PortfolioBuilder {
		this.portfolio.type = type;
		return this;
	}

	public setUniqueId(uniqueId: string): PortfolioBuilder {
		this.portfolio.uniqueId = uniqueId;
		return this;
	}

	public setDateLastModified(dateLastModified: string): PortfolioBuilder {
		this.portfolio.dateLastModified = dateLastModified;
		return this;
	}

	public setPortfolioId(portfolioId: number): PortfolioBuilder {
		this.portfolio.portfolioId = portfolioId;
		return this;
	}

	public setPerformanceReturns(performanceReturn: PerformanceReturn): PortfolioBuilder {
		this.portfolio.performanceReturn = performanceReturn;
		return this;
	}

	public setRiskScenarios(riskScenarios: Map<string, number>): PortfolioBuilder {
		this.portfolio.riskScenarios = riskScenarios;
		return this;
	}

	public setSecurities(securities: Array<Security>): PortfolioBuilder {
		this.portfolio.securities = securities;
		return this;
	}

	public setRiskAnalytics(riskAnalytics: RiskAnalytics): PortfolioBuilder {
		this.portfolio.riskAnalytics = riskAnalytics;
		return this;
	}

	public setYieldValue(analyticsMap: any): PortfolioBuilder {
		this.portfolio.yieldValue = analyticsMap ? (analyticsMap.twelveMonthTrailingYield ? analyticsMap.twelveMonthTrailingYield.value : null) : null;
		return this;
	}

	public setLastModifyingUser(user: string): PortfolioBuilder {
		this.portfolio.lastModifyingUser = user ? user : '';
		return this;
	}

	public setCurrentUserIsOwner(isOwner: boolean): PortfolioBuilder {
		this.portfolio.currentUserIsOwner = isOwner;
		return this;
	}

	public setOwner(owner: string): PortfolioBuilder {
		this.portfolio.owner = owner;
		return this;
	}

	public setPerms(perms: string[]): PortfolioBuilder {
		this.portfolio.perms = perms;
		return this;
	}

	public setBaseEngagementPortfolio(baseEngagementPortfolio: string): PortfolioBuilder {
		this.portfolio.baseEngagementPortfolio = baseEngagementPortfolio;
		return this;
	}

	public build(): Portfolio {
		return this.portfolio;
	}
}
